
import $ from 'jquery';
import _ from 'lodash';

export function validName(input) {
    var regex = new RegExp('^[^0-9]*$');
    if (regex.test(input.trim())) {
        return true;
    } else {
        return false;
    }
}

export function validInputCharacters(input) {

    // Wo do not care for empty strings or other falsy inputs - these should be handled by required.
    if ( String( input || '' ).trim().length <= 0 ) {
        return true;
    }

    // Test for valid characters.
    const regex = new RegExp(/^[\w\-\.'´`\/\s@]+$/);
    return regex.test(_.deburr( String( input ).trim()));
}

export function validPluscard(input) {
    var regex = new RegExp(/^[\d\s]+$/g);
    if (regex.test(input.trim())) {
        return true;
    } else {
        return false;
    }
}

export function validEmail(input) {
    var validmailregex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
    if (validmailregex.test(input)) {
        return true;
    } else {
        return false;
    }
}

export function validateAddress(value, event) {
    return /[0-9](.*)/gm.test(value);
}

export function validNumber( value ) {
    const testRegex = /^\d+$/;
    return testRegex.test( value || '' );
};

export function validInputNumber(input) {
    if (typeof input === 'undefined') return false;
    var reg = new RegExp('^[0-9]+$');
    return reg.test(input.toString())
}

export function validPasswordCharactersOld(input) {
    return validPasswordCharacters(input, false);
}

export function validPasswordCharacters(input, withlength) {
    return ((withlength && ($.trim(input).length > 7)) || (!withlength));
}

export function validPhone(input, _default) {
    if ( !window.libphonenumber ) return _default || false;

    const parsed = window.libphonenumber.parsePhoneNumberFromString( input );
    if ( ! parsed ) {
        return false;
    }

    return parsed.isValid();
}

export function validPLCCharacters(input, withlength) {
    var regex = new RegExp('^[0-9]*$');
    if (regex.test(input)) {
        return true;
    } else {
        return false;
    }
}

export function valueMatchesWithField( input, compareField ) {

    // Check if the two values match.
    return input === $( compareField ).val();
}


export function isUrlValid(userInput) {
    var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    if(res == null)
        return false;
    else
        return true;
}

/**
 * Checks whether the string length is bigger than maxLength
 */
export function checkLength( input, maxLength ) {
    return $.trim( input || '' ).length > (maxLength || 0);
}

export function checkMinLength( input, minLength ) {
    return $.trim( input || '' ).length < (minLength || 0);
}

/**
 * Get a jQuery Selector and check if the given Field value is empty.
 */
export function isEmptyInput( selector ) {
    const value = $( selector ).val();
    return ! checkLength( value, 0 );
}

/**
 * Validate a Username ( E-Mail Adress ).
 */
export function isValidUsernameInput( selector ) {
    const value = $( selector ).val();
    return checkLength( value, 0 ) && validEmail( value );
}

/**
 * Validate a Password Input Field.
 */
export function isValidPasswordInput( selector ) {
    const value = $( selector ).val();
    return checkLength( value, 0 ) && validPasswordCharacters( value, true );
}


global.validName = validName;
global.validInputCharacters = validInputCharacters;
global.validPluscard = validPluscard;
global.validEmail = validEmail;
global.validNumber = validNumber;
window.validateAddress = validateAddress;
global.validInputNumber = validInputNumber;
global.validPasswordCharacters = validPasswordCharacters;
global.validPhone = validPhone;
global.validPLCCharacters = validPLCCharacters;
global.isUrlValid = isUrlValid;
global.isEmptyInput = isEmptyInput;
global.isValidUsernameInput = isValidUsernameInput;
global.isValidPasswordInput = isValidPasswordInput;
